import * as React from 'react';
import styled, { css } from 'styled-components';
import { statusType } from '..';

export interface ProgressLineProps {
  className?: string;
  status?: statusType;
  progress?: number;
  hasVerticalError?: boolean;
}

export const ProgressLine: React.FC<ProgressLineProps> = (props) => (
  <span
    className={`${props.className} ${
      props.hasVerticalError && props.status === 'error' ? 'vertical-error' : ''
    }`}
  ></span>
);

export default styled(ProgressLine)`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.menuBackground};
  border-radius: 0 0 4px 4px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 0 0 4px 4px;
    transition: background-color
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`},
      width
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  ${(props) =>
    props.status === 'uploading'
      ? css`
          &:after {
            background-color: ${({ theme }) => theme.colors.upload};
            border-radius: 0 0 0 4px;
            width: ${props.progress ? props.progress : 0}%;
          }
        `
      : null}

  ${(props) =>
    props.status === 'done'
      ? css`
          &:after {
            background-color: ${({ theme }) => theme.colors.success};
          }
        `
      : null}

  ${(props) =>
    props.status === 'error'
      ? css`
          &:after {
            background-color: ${({ theme }) => theme.colors.error};
          }
        `
      : null}
`;
